import { useRef, useState, useEffect } from "react";
import HomeComponent from "../HomeComponent/HomeComponent";

const CameraComponent = () => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [imageData, setImageData] = useState(null);
    const [stream, setStream] = useState(null);
    const [showPermissionDialog, setShowPermissionDialog] = useState(false);
    const [cameraFacing, setCameraFacing] = useState("environment"); // "user" for front, "environment" for back

    // 📸 Start Camera
    const startCamera = async (facingMode = "environment") => {
        try {
            if (stream) {
                stream.getTracks().forEach(track => track.stop()); // Stop previous stream
            }

            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode },
            });

            if (videoRef.current) {
                videoRef.current.srcObject = mediaStream;
                setStream(mediaStream);
            }
        } catch (error) {
            console.error("Error accessing camera:", error);

            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

            if (isMobile) {
                alert(
                    "Please enable camera access in your browser settings:\n\n" +
                    "• On **iPhone (Safari)**: Go to **Settings > Safari > Camera**\n" +
                    "• On **Android (Chrome)**: Go to **Settings > Site Settings > Camera**\n\n" +
                    "Then **reload the page**."
                );
            } else {
                setShowPermissionDialog(true);
            }
        }
    };

    useEffect(() => {
        startCamera(cameraFacing);

        return () => {
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }
        };
    }, [cameraFacing]);

    // 📷 Capture Image
    const captureImage = () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        if (video && canvas) {
            const context = canvas.getContext("2d");
            canvas.width = 640;
            canvas.height = 480;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            const dataUrl = canvas.toDataURL("image/jpeg", 0.7);
            setImageData(dataUrl);
        }
    };

    // 🔄 Convert Base64 to Blob
    const dataURLtoBlob = (dataURL) => {
        const byteString = atob(dataURL.split(",")[1]);
        const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };

    // 📤 Send Image to API
    const uploadImage = async () => {
        if (!imageData) {
            alert("Capture an image first!");
            return;
        }

        const blob = dataURLtoBlob(imageData);
        const formData = new FormData();
        formData.append("image", blob, "capture.png");

        try {
            const response = await fetch("https://localhost:7037/api/users/UploadImage", {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                alert("Image uploaded successfully!");
            } else {
                alert("Failed to upload image.");
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    };

    return (
        <div style={{ textAlign: "center" }}>
            {/* Camera Preview */}
            <div style={{ width: "100%", maxWidth: "400px", margin: "auto", border: "2px solid black" }}>
                <video ref={videoRef} autoPlay playsInline style={{ width: "100%", height: "auto" }} />
            </div>

            {/* Hidden Canvas */}
            <canvas ref={canvasRef} style={{ display: "none" }} />

            {/* Camera Switch Dropdown */}
            <div style={{ marginTop: "10px" }}>
                <label style={{ fontWeight: "bold", marginRight: "10px" }}>Select Camera:</label>
                <select value={cameraFacing} onChange={(e) => setCameraFacing(e.target.value)} style={{ padding: "5px" }}>
                    <option value="environment">📷 Back Camera</option>
                    <option value="user">🤳 Front Camera</option>
                </select>
            </div>

            {/* Buttons */}
            <div style={{ marginTop: "10px" }}>
                <button onClick={captureImage} style={{ padding: "10px 20px", marginRight: "10px" }}>
                    📷 Capture
                </button>
                {imageData && (
                    <button onClick={uploadImage} style={{ padding: "10px 20px" }}>
                        📤 Save
                    </button>
                )}
            </div>

            {/* Show captured image */}
            {imageData && (
                <div style={{ marginTop: "10px" }}>
                    <img src={imageData} alt="Captured" style={{ width: "100%", maxWidth: "400px", border: "2px solid black" }} />
                </div>
            )}

            {/* Custom Permission Dialog */}
            {showPermissionDialog && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <div style={{ background: "white", padding: "20px", borderRadius: "10px", textAlign: "center" }}>
                        <p>Camera access is blocked. Click the button below to allow access.</p>
                        <button onClick={() => {
                            window.open("chrome://settings/content/camera", "_blank");
                            setShowPermissionDialog(false);
                        }} style={{ padding: "10px 15px", marginRight: "10px" }}>
                            Open Camera Settings
                        </button>
                        <button onClick={() => setShowPermissionDialog(false)} style={{ padding: "10px 15px" }}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            <div>
                <HomeComponent />
            </div>
        </div>
    );
};

export default CameraComponent;
